"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TogglerContainer = exports.ModuleIconInner = exports.ModuleIcon = exports.MenuToggler = exports.HeaderInner = exports.HeaderContainer = exports.BreadcrumbsArea = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HeaderContainer = exports.HeaderContainer = _styledComponents.default.header.withConfig({
  displayName: "styles__HeaderContainer",
  componentId: "sc-h9ixzi-0"
})(["width:100%;height:", ";background:", ";border-bottom:1px solid ", ";z-index:200;"], ({
  theme
}) => theme.AppFrame.header.height, ({
  theme
}) => theme.colors.appFrame.header.bg, ({
  theme
}) => theme.colors.appFrame.header.borderColor);
const HeaderInner = exports.HeaderInner = _styledComponents.default.div.withConfig({
  displayName: "styles__HeaderInner",
  componentId: "sc-h9ixzi-1"
})(["align-items:center;position:relative;height:100%;display:flex;box-sizing:border-box;width:100%;"]);
const TogglerContainer = exports.TogglerContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__TogglerContainer",
  componentId: "sc-h9ixzi-2"
})(["flex-shrink:0;width:", ";height:48px;padding:8px 0;transition:margin-right 0.3s ease-in-out;", ";", ";"], ({
  theme
}) => theme.AppFrame.menu.collapsedWidth, ({
  theme
}) => (0, _styledComponents.css)(["margin-right:calc(", " - ", ");"], theme.AppFrame.menu.expandedWidth, theme.AppFrame.menu.collapsedWidth), ({
  collapsed
}) => collapsed && (0, _styledComponents.css)(["margin-right:0;"]));
const MenuToggler = exports.MenuToggler = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuToggler",
  componentId: "sc-h9ixzi-3"
})(["cursor:pointer;width:100%;height:100%;border-right:1px solid ", ";z-index:100;position:relative;& span{bottom:auto;left:50%;right:auto;top:50%;transform:translateX(-50%) translateY(-50%);position:absolute;width:22px;height:2px;border-radius:1px;background-color:", ";&:before,&:after{content:'';width:22px;height:2px;border-radius:1px;background-color:", ";position:absolute;}&:before{transform:translateY(-7px);}&:after{transform:translateY(7px);}}"], ({
  theme
}) => theme.colors.appFrame.menu.line, ({
  theme
}) => theme.colors.appFrame.header.menuToggler, ({
  theme
}) => theme.colors.appFrame.header.menuToggler);
const BreadcrumbsArea = exports.BreadcrumbsArea = _styledComponents.default.div.withConfig({
  displayName: "styles__BreadcrumbsArea",
  componentId: "sc-h9ixzi-4"
})(["position:relative;width:100%;height:100%;background-color:", ";"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.containerBg);
const ModuleIcon = exports.ModuleIcon = _styledComponents.default.div.withConfig({
  displayName: "styles__ModuleIcon",
  componentId: "sc-h9ixzi-5"
})(["width:56px;height:100%;padding:8px 12px;"]);
const ModuleIconInner = exports.ModuleIconInner = _styledComponents.default.div.withConfig({
  displayName: "styles__ModuleIconInner",
  componentId: "sc-h9ixzi-6"
})(["width:32px;height:32px;background-repeat:no-repeat;background-size:contain;background-position:50% 50%;background-image:url(", ");"], ({
  icon
}) => icon);